import React, { Component } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
// import { renderRoutes } from 'react-router-config';
import "./App.scss";
import userService from "./services/userService";

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./pages/login"));
const Register = React.lazy(() => import("./views/Pages/Register"));
const Page404 = React.lazy(() => import("./views/Pages/Page404"));
const Page500 = React.lazy(() => import("./views/Pages/Page500"));

class App extends Component {
  constructor() {
    super();
    this.state = { isLogin: false };
    if (window.user) {
      this.state.isLogin = true;
    }
    this.handlerLogin = this.handlerLogin.bind(this);
    this.userServiceInstance = new userService();
    this.inactivityTime = 30 * 60 * 1000;
    this.logoutTimer = null;
    this.resetTimer = this.resetTimer.bind(this);
    this.handleAutoLogout = this.handleAutoLogout.bind(this);
    this.checkInactivityOnLoad = this.checkInactivityOnLoad.bind(this);
    this.visibilityChangeHandler = () => {
      if (!document.hidden && window.user) {
        this.checkInactivityOnLoad();
      }
      this.resetTimer();
    };

    this.focusHandler = () => {
      if (window.user) {
        this.checkInactivityOnLoad();
      }
      this.resetTimer();
    };
  }

  componentDidMount() {
    this.checkInactivityOnLoad();
    this.setupInactivityTracking();
  }

  componentWillUnmount() {
    this.removeInactivityTracking();
  }

  checkInactivityOnLoad() {
    if (window.user) {
      const lastActivityTime = localStorage.getItem("lastActivityTime");
      if (lastActivityTime) {
        const timeSinceLastActivity = Date.now() - parseInt(lastActivityTime);
        if (timeSinceLastActivity >= this.inactivityTime) {
          this.handleAutoLogout();
          return;
        }
      }
    }
  }

  setupInactivityTracking() {
    const events = [
      "mousemove",
      "keydown",
      "mousedown",
      "touchstart",
      "scroll",
    ];
    events.forEach((event) => {
      window.addEventListener(event, this.resetTimer);
    });
    document.addEventListener("visibilitychange", this.visibilityChangeHandler);
    window.addEventListener("focus", this.focusHandler);
    this.resetTimer();
  }

  removeInactivityTracking() {
    const events = [
      "mousemove",
      "keydown",
      "mousedown",
      "touchstart",
      "scroll",
    ];
    events.forEach((event) => {
      window.removeEventListener(event, this.resetTimer);
    });
    document.removeEventListener(
      "visibilitychange",
      this.visibilityChangeHandler
    );
    window.removeEventListener("focus", this.focusHandler);
    if (this.logoutTimer) {
      clearTimeout(this.logoutTimer);
    }
  }

  resetTimer() {
    if (this.logoutTimer) {
      clearTimeout(this.logoutTimer);
    }
    if (window.user) {
      localStorage.setItem("lastActivityTime", Date.now().toString());
      this.logoutTimer = setTimeout(this.handleAutoLogout, this.inactivityTime);
    }
  }

  handleAutoLogout() {
    this.userServiceInstance.logout();
    localStorage.removeItem("lastActivityTime");
    this.setState({ isLogin: false });
    window.location.hash = "#/login";
  }

  handlerLogin(islogin) {
    this.setState({ isLogin: islogin });
    if (islogin) {
      localStorage.setItem("lastActivityTime", Date.now().toString());
    }
  }

  render() {
    return (
      <HashRouter>
        <React.Suspense fallback={loading()}>
          <Switch>
            <Route
              exact
              path="/login"
              name="Login Page"
              render={(props) => (
                <Login
                  handlerLoginParent={this.handlerLogin.bind(this)}
                  {...props}
                />
              )}
            />
            {/* <Route
              exact
              path="/"
              name="Login Page"
              render={props => (
                <Login
                  handlerLoginParent={this.handlerLogin.bind(this)}
                  {...props}
                />
              )}
            /> */}
            {/* <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} /> */}
            <Route
              exact
              path="/404"
              name="Page 404"
              render={(props) => <Page404 {...props} />}
            />
            <Route
              exact
              path="/500"
              name="Page 500"
              render={(props) => <Page500 {...props} />}
            />
            <Route
              path="/"
              name="Home"
              render={(props) =>
                !window.user ? (
                  <Login
                    handlerLoginParent={this.handlerLogin.bind(this)}
                    {...props}
                  />
                ) : (
                  <DefaultLayout {...props} />
                )
              }
            />
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
